import styled from 'styled-components';
import TextField from '@omilia/text-field';
import { colors } from '@omilia/theme';

// TODO: Remove this, when we remove FOUNDATION.
// Right now they exist to override the css that
// FOUNDATION adds
const SFixedTextField = styled(TextField)`
  &&& {
    border-left: none;
    border-radius: 0;
    border-right: none;
    border-top: none;
    box-shadow: none;
    margin-bottom: 14px;
    margin-top: 0;
    z-index: initial;
  }

  &&&:focus {
    border-bottom: 2px solid ${colors.COLOR_BLUE_500};
  }
`;

export default SFixedTextField;
